import * as d3 from 'd3'
import d3tip from '../ultils/d3-tip'

class Chart {
  constructor(element, initProps) {
    let vis = this
    vis.initProps = initProps
    vis.isResponsive = initProps.isResponsive ?? false

    vis.svg = d3
      .select(element)
      .append('svg')
      .attr('width', 0)
      .attr('height', 0)
    vis.g = vis.svg.append('g')
  }

  setDimensions(width, height, margin = {}) {
    let vis = this
    const { TOP = 10, BOTTOM = 10, LEFT = 10, RIGHT = 10 } = margin

    vis.MARGIN = { TOP, BOTTOM, LEFT, RIGHT }
    vis.WIDTH = width - vis.MARGIN.LEFT - vis.MARGIN.RIGHT
    vis.HEIGHT = height - vis.MARGIN.TOP - vis.MARGIN.BOTTOM

    if (vis.isResponsive) {
      const totalWidth = vis.WIDTH + vis.MARGIN.LEFT + vis.MARGIN.RIGHT - 100
      const totalHeight = vis.HEIGHT + vis.MARGIN.TOP + vis.MARGIN.BOTTOM

      vis.svg
          .attr('viewBox', `0 0 ${totalWidth} ${totalHeight}`)
          .attr('preserveAspectRatio', 'xMidYMid meet')
          .style('width', '100%')
          .style('height', '100%')
    } else {
      vis.svg
          .attr('width', vis.WIDTH + vis.MARGIN.LEFT + vis.MARGIN.RIGHT)
          .attr('height', vis.HEIGHT + vis.MARGIN.TOP + vis.MARGIN.BOTTOM)
    }

    vis.g.attr('transform', `translate(${vis.MARGIN.LEFT}, ${vis.MARGIN.TOP})`)

    if (vis.initComplete) vis.update({})
    else {
      vis.init(vis.initProps)
      vis.initComplete = true
    }
  }
}

export default Chart
